import axios from 'axios';
import { ADMIN_NPS_SURVEY_ROUTE } from '../../api/backend';
import { NpsSurveySettings } from '../../common/model/dto/survey/nps-survey-settings';
import { Survey } from '../../common/model/dto/survey/survey';
import { SurveyResponse } from '../../common/model/dto/survey/survey-response';
import { Paginated } from '../../common/types';

export class AdminNpsSurveyService {
  static RESPONSE_LIST_LIMIT = 10;

  static async getCurrentNpsSurvey(): Promise<Survey> {
    const { data } = await axios.get<Survey>(`${ADMIN_NPS_SURVEY_ROUTE}`);

    return data;
  }

  static async getNpsSurveyById(id: string): Promise<Survey> {
    const { data } = await axios.get<Survey>(`${ADMIN_NPS_SURVEY_ROUTE}/${id}`);

    return data;
  }

  static async createNpsSurvey(npsSurvey: Survey): Promise<Survey> {
    const { data } = await axios.post<Survey>(
      `${ADMIN_NPS_SURVEY_ROUTE}`,
      npsSurvey
    );

    return data;
  }

  static async updateNpsSurvey(npsSurvey: Survey): Promise<Survey> {
    const { data } = await axios.patch<Survey>(
      `${ADMIN_NPS_SURVEY_ROUTE}/${npsSurvey.id}`,
      npsSurvey
    );

    return data;
  }

  static async sendNpsSurveyToUsers(): Promise<Survey> {
    const { data } = await axios.post<Survey>(
      `${ADMIN_NPS_SURVEY_ROUTE}/send-to-users`,
      null
    );

    return data;
  }

  static async getSurveyResponses(
    query: string
  ): Promise<Paginated<SurveyResponse>> {
    const { data } = await axios.get<Paginated<SurveyResponse>>(
      `${ADMIN_NPS_SURVEY_ROUTE}/responses?${query}`
    );

    return data;
  }

  static async getNpsSurveySettings(): Promise<NpsSurveySettings> {
    const { data } = await axios.get<NpsSurveySettings>(
      `${ADMIN_NPS_SURVEY_ROUTE}/settings`
    );

    return data;
  }

  static async updateNpsSurveySettings(
    npsSurveySettings: NpsSurveySettings
  ): Promise<NpsSurveySettings> {
    const { data } = await axios.patch<NpsSurveySettings>(
      `${ADMIN_NPS_SURVEY_ROUTE}/settings`,
      npsSurveySettings
    );

    return data;
  }

  static async deleteSurveyResponse(id: string) {
    return await axios.delete(`${ADMIN_NPS_SURVEY_ROUTE}/responses/${id}`);
  }

  static async loadAllAppVersions() {
    const { data } = await axios.get<
      {
        app_version: string;
      }[]
    >(`${ADMIN_NPS_SURVEY_ROUTE}/app-versions`);

    return data;
  }

  static async loadAllDevices() {
    const { data } = await axios.get<
      {
        device_model: string;
      }[]
    >(`${ADMIN_NPS_SURVEY_ROUTE}/devices`);

    return data;
  }

  static async loadAllOsVersions() {
    const { data } = await axios.get<
      {
        os_version: string;
      }[]
    >(`${ADMIN_NPS_SURVEY_ROUTE}/os-versions`);

    return data;
  }

  static async getNetPromoterScore() {
    const { data } = await axios.get<number>(
      `${ADMIN_NPS_SURVEY_ROUTE}/net-promoter-score`
    );

    return data;
  }
}
